import { type ReactNode } from 'react'
import classNames from 'classnames'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import { type ITooltipProps, Typography, Tooltip, Icon, IconButton } from 'shared/ui'

import styles from './styles.module.scss'

type IRcsInfoFormRowProps = {
  variant?: 'default' | 'media' | 'paragraph' | 'field'
  className?: string
  tooltipProps?: ITooltipProps
  label: string
  children: ReactNode
  copyValue?: string
}

export const RcsInfoFormRow = ({
  label,
  children,
  tooltipProps,
  copyValue,
  variant = 'default',
  className,
}: IRcsInfoFormRowProps) => {
  const { onCopy } = useCopyToClipboard(copyValue, { showToast: true, mode: 'stateless' })

  return (
    <div
      className={classNames(
        styles.row,
        {
          [styles.rowMedia]: variant === 'media',
          [styles.rowField]: variant === 'field',
        },
        className
      )}
    >
      <div className={styles.label}>
        <Typography
          variant='text-input-field-r'
          ariaLabel='RcsInfoFormRowLabel'
          color='var(--content-primary-secondary)'
          width={tooltipProps ? 'auto' : '188px'}
        >
          {label}
        </Typography>
        {tooltipProps && (
          <Tooltip label={tooltipProps.label} placement='top'>
            <Icon
              icon='question'
              color='var(--content-neutral-primary)'
              fontSize={12}
              className={styles.questionIcon}
            />
          </Tooltip>
        )}
      </div>
      <div
        className={classNames(styles.value, { [styles.valueParagraph]: variant === 'paragraph' })}
      >
        {children}
      </div>
      {copyValue && (
        <IconButton
          ariaLabel='copy'
          icon='copy'
          size='small'
          variant='icon'
          color='tertiary'
          tooltipProps={{
            label: 'Copy link',
            placement: 'top',
          }}
          onClick={onCopy}
        />
      )}
    </div>
  )
}
